module.exports = __webpack_public_path__ + "b0033431ad69136be02ee07801bab108.svg";